import addMonths from 'date-fns/esm/addMonths';
import endOfDay from 'date-fns/esm/endOfDay';
import dateFnsFormat from 'date-fns/esm/format';
import isBefore from 'date-fns/esm/isBefore';
import isWithinInterval from 'date-fns/esm/isWithinInterval';
import parse from 'date-fns/esm/parse';
import startOfMonth from 'date-fns/esm/startOfMonth';
import range from 'lodash-es/range';

const fiscalRange = {
  endMonth: 7,
  startMonth: 8
};

export const enum OldestFiscalYears {
  CallGoals = '2015',
  CoOp = '2019',
  PreSeason = '2016',
  Programs = '2018',
  SalesCall = '2014'
}

export function getFiscalYear(date?: Date | string): string {
  date = date ? new Date(date) : new Date();
  if (date.getMonth() >= fiscalRange.startMonth) {
    return (date.getFullYear() + 1).toString();
  }
  return date.getFullYear().toString();
}

export function getFiscalYearRange(fiscalYear: string = ''): { start: Date; end: Date } {
  if (!fiscalYear) {
    fiscalYear = getFiscalYear();
  }

  const dFormat: string = 'M-dd-yyyy';

  const end = parse(`${fiscalRange.endMonth + 1}-31-${Number(fiscalYear)}`, dFormat, new Date());
  const start = parse(`${fiscalRange.startMonth + 1}-01-${Number(fiscalYear) - 1}`, dFormat, new Date());

  return {
    end: endOfDay(end),
    start
  };
}

export function getFiscalMonths(
  fiscalYear: string = getFiscalYear(),
  format: 'MMM' | 'MMMM' = 'MMM'
): { label: string; jsMonthId: number; isInPast: boolean }[] {
  const dateRange = getFiscalYearRange(fiscalYear);
  const months: { label: string; jsMonthId: number; isInPast: boolean }[] = [];
  let current = dateRange.start;
  const now = startOfMonth(new Date());

  while (isWithinInterval(current, dateRange)) {
    months.push({
      isInPast: isBefore(current, now),
      jsMonthId: current.getMonth(),
      label: dateFnsFormat(current, format)
    });

    current = addMonths(current, 1);
  }

  return months;
}

export function getFiscalYearArray(startYear: string, endYear?: string): string[] {
  endYear = endYear ? endYear : getFiscalYear();

  return range(Number(startYear), Number(endYear) + 1).map(x => x.toString());
}

export function getFiscalQuarter(date: Date | string = new Date()): number {
  // get the javascript fiscal month numbers
  const months = getFiscalMonths().map(x => x.jsMonthId);
  // find the index of the month
  const monthIdx = months.indexOf(new Date(date).getMonth());
  // divide the index number by three, round down, and add one
  const quarter = Math.floor(monthIdx / 3) + 1;
  return quarter;
}

export function getFiscalRange(yearsPastCurrentFiscal: number = 0, startFiscal?: string): string[] {
  const currentFiscalNum = Number(getFiscalYear());
  const startFiscalNum = startFiscal ? Number(startFiscal) : Number(getFiscalYear());
  const fiscalDiff = currentFiscalNum - startFiscalNum;

  return range(startFiscalNum, startFiscalNum + fiscalDiff + yearsPastCurrentFiscal + 1).map(x => x.toString());
}
